import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="min-vh-100 d-flex align-items-center ">
            <Container className="py-5">
                <Row className="justify-content-center text-center">
                    <Col lg={8} md={10} className="px-4">
                        <Card className="card-hover menu-item-card mb-0 mx-auto" >
                            <Card.Body>
                                {/* 404 Illustration */}
                                <div className="position-relative mb-4" >
                                    <h1 className="display-1 fw-bold text-danger">404</h1>
                                </div>

                                {/* Error Message */}
                                <h2 className="display-5 fw-bold mb-3">Oops! Page Not Found</h2>
                                <p className="lead text-muted mb-4">The page you're looking for doesn't exist or has been moved. Let's get you back on track to delicious food! 🍽️</p>

                                {/* Action Buttons */}
                                <div className="d-flex flex-wrap justify-content-center gap-3 mb-5">
                                    <Button as={Link} to="/" variant="danger" size="lg" >
                                        <i className="ri-home-4-line me-2"></i> Back to Home
                                    </Button>

                                    <Button as={Link} to="/menu" variant="dark" size="lg" >
                                        <i className="ri-restaurant-line me-2"></i> Explore Menu
                                    </Button>
                                </div>

                                {/* Search Bar */}
                                <div className=" p-4 rounded-3 shadow-sm" style={{ maxWidth: '600px', margin: '0 auto' }}>
                                    <p className="text-muted mb-3">Or search for what you're looking for:</p>
                                    <div className="input-group mb-3">
                                        <input type="text" className="form-control form-control-lg border-end-0" placeholder="Search dishes, cuisines..." />
                                        <Button variant="danger">
                                            <i className="ri-search-line"></i>
                                        </Button>
                                    </div>
                                </div>

                                {/* Help Section */}
                                <div className="mt-5 pt-4 border-top">
                                    <p className="text-muted mb-4">Need help? Contact our support team</p>
                                    <div className="d-flex justify-content-center gap-4">
                                        <a href="mailto:support@reshto.com" className="text-decoration-none">
                                            <i className="ri-customer-service-line me-2"></i> support@reshto.com
                                        </a>
                                        <span className="text-muted">|</span>
                                        <a href="tel:+1234567890" className="text-decoration-none">
                                            <i className="ri-phone-line me-2"></i> +1 (234) 567-890
                                        </a>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default NotFound;
